AuthLocationInterceptor = ($rootScope, $location, returnUrl, AuthService) ->

  signInRequired = (route) ->
    route?.$$route?.permission?.signInRequired

  $rootScope.$on "$routeChangeStart", (event, next, current) ->
    return if AuthService.isSignedIn()
    return unless signInRequired(next)

    # save return url and move to sign in page
    returnUrl.url = $location.path()
    event.preventDefault()
    $location.path '/session/new'

AuthLocationInterceptor.$inject = [
  '$rootScope'
  '$location'
  'returnUrl'
  'AuthService'
]

module.exports = AuthLocationInterceptor



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/auth/auth-location-interceptor.coffee